import axios from '@/api/config';

const fodderGroupInfo = {
    addFodderGroupInfo(data) {
        return axios.post(`${process.env.BASE_URL}/fodderGroupInfo/addFodderGroupInfo`, data);
    },
    deleteFodderGroupInfo(data) {
        return axios.delete(`${process.env.BASE_URL}/fodderGroupInfo/deleteFodderGroupInfo`, {data:data});
    },
    getFodderGroupInfoTree(data) {
        return axios.post(`${process.env.BASE_URL}/fodderGroupInfo/getFodderGroupInfoTree`, data);
    },
    addAttachment(data) {
        return axios.post(`${process.env.BASE_URL}/fodderGroupInfo/addAttachment`, data);
    },
    transferFodder(data) {
        return axios.post(`${process.env.BASE_URL}/fodderGroupInfo/transferFodder`, data);
    },
    transferFodderByFodderGroupInfoId(data) {
        return axios.post(`${process.env.BASE_URL}/fodderGroupInfo/transferFodderByFodderGroupInfoId`, data);
    },
    updateAttachment(data) {
        return axios.put(`${process.env.BASE_URL}/fodderGroupInfo/updateAttachment`, data);
    },
    updateFodderGroupInfo(data) {
        return axios.put(`${process.env.BASE_URL}/fodderGroupInfo/updateFodderGroupInfo`, data);
    },
    getAttachmentByType(data) {
        return axios.get(`${process.env.BASE_URL}/fodderGroupInfo/getAttachmentByType`, {params:data});
    },
}

export default fodderGroupInfo;



// WEBPACK FOOTER //
// ./src/api/fodderGroupInfo.js